import { useNotificationsSubscription } from './chunk-ZB7J72FH.mjs';
import { useFeatureFlagSubscription } from './chunk-5KFXAVVR.mjs';
import { __export } from './chunk-YUBKM3FG.mjs';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

// src/providers/query/index.tsx
var query_exports = {};
__export(query_exports, {
  QueryProvider: () => QueryProvider,
  useQueryContext: () => useQueryContext
});
var queryClient = new QueryClient();
var QueryContext = createContext(void 0);
var QueryContextProvider = (props) => {
  const { config, children } = props;
  const { hasuraUrl } = config;
  const featureFlags = useFeatureFlagSubscription(hasuraUrl);
  const notifications = useNotificationsSubscription(hasuraUrl);
  const contextValue = {
    hasuraUrl,
    featureFlags,
    notifications,
    invalidateQuery: (queryKey) => {
      queryClient.removeQueries({ queryKey, exact: true });
      queryClient.refetchQueries({
        queryKey,
        exact: true,
        type: "active"
      });
    }
  };
  return /* @__PURE__ */ jsx(QueryContext.Provider, { value: contextValue, children });
};
var QueryProvider = ({ config, children }) => {
  return /* @__PURE__ */ jsx(QueryClientProvider, { client: queryClient, children: /* @__PURE__ */ jsx(QueryContextProvider, { config, children }) });
};
var useQueryContext = () => {
  const context = useContext(QueryContext);
  if (!context) {
    throw new Error("useQueryContext must be used within an QueryProvider");
  }
  return context;
};

export { QueryProvider, query_exports, useQueryContext };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-PJDJ4H2H.mjs.map